import React,{ useEffect, useState, useCallback } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { Iconfont } from "../../../../../../components/icon/iconfont";
import { useRef } from "react";
import { fetchShareUrl, fetchProductShareSuccess } from "../../../../../../../api";
import { IMAGE_GEEKO_LTD } from "../../../../../../../constants";
import { FacebookShareButton, PinterestShareButton } from "react-share";
import SendToMessenger from "../../../module/send-to-messenger";
import { useSelector } from "react-redux";
import ZoomImagePopover from "../../../module/zoom-image-popover";
import { setZoomImagePopover } from "../../../../../../../store/actions/pages/product";
import { useDispatch } from "react-redux";
import InnerImageZoom from 'react-inner-image-zoom';
import ShopSimilar from "../../../module/shop-similar";
import ReactPlayer from "react-player/lazy"
import { action_fetch_customer } from "../../../../../../../store/actions/pages/customer";

const LeftImageList = props =>{
    useStyles(classes);
    const { 
            product, 
            imagePrefix, 
            changeSelectedImage, 
            images, 
            currentIndex, 
            changeCurrentIndex
        } = props;
    
    const [currentCount,setCurrentCount] = useState(0);
    const sumCount = useRef(Math.ceil((images.length - 10) / 2));

    const isVideo = product?.listingVideoLink;

    useEffect(()=>{
        if(product?.id){
            changeSelectedImage(images?.[0]);
            changeCurrentIndex(0);
        }
    },[product?.id]);

    const toggleEvent = (mode) =>{
        if(mode == "prev"){
            setCurrentCount(state =>state+1);
        }else{
            setCurrentCount(state =>state-1);
        }
    }

    const imageClickEvent = (item,index) =>{
        changeSelectedImage(item);
        changeCurrentIndex(index);
    }

    return <div className={classes.LeftImageList}>
        <div className={classes.TopItem}>
            <ul className={classes.ImageListUl} style={{top:`${currentCount*114}px`}}>
                {
                    images?.length > 0 && <>
                        {
                            images.map((item,index) =>{
                                return <li key={item+index}>
                                    <div 
                                        style={{backgroundImage:`url(${imagePrefix}/small/${item})`}} 
                                        className={`${classes.ImageItem} ${index==currentIndex?classes.active:""}`}
                                        onClick={()=>imageClickEvent(item,index)}
                                    >
                                        {
                                            isVideo && index === 0 && <Iconfont className={classes.VideoPlay}>&#xe63c;</Iconfont>
                                        }
                                    </div>
                                </li>
                            })
                        }
                    </>
                }
            </ul>
        </div>
        
        <div className={classes.ButtonContainer}>
            <button className="iconfont" disabled={currentCount==0} onClick={()=>toggleEvent("prev")}>
                <Iconfont className={classes.Icon}>&#xe695;</Iconfont>
            </button>
            <button className="iconfont" disabled={sumCount.current <=0 || Math.abs(currentCount)==sumCount.current} onClick={()=>toggleEvent("next")}>
                <Iconfont className={classes.Icon}>&#xe692;</Iconfont>
            </button>
        </div>
    </div>
}


const ProductShareContainer = props =>{
    const { selectedProduct } = props;
    const [shareUrl, setShareUrl] = useState(null);
    const global = useSelector(state =>state.global);
    const pageCustomer = useSelector(state=>state.pageCustomer);
    const { customer } = pageCustomer;

    useEffect(async () => {
        let response = await fetchShareUrl({ urlCode: "P01D", params: JSON.stringify({ productId: selectedProduct?.id }) });
        if (response?.code === 200) {
            setShareUrl(response?.result);
        } else {
            alert(response?.result);
        }
    }, [selectedProduct?.id]);

    
    const shareSuccess = async (type) =>{
        await fetchProductShareSuccess(selectedProduct?.id,type);
    }

    return <div className={classes.ProductShareContainer}>
        <div className={classes.Share}>
            <FacebookShareButton
                url={shareUrl?.facebook}
                onShareWindowClose={()=>shareSuccess("facebook")}
            >
                <Iconfont className={classes.FacebookIcon}>&#xe65e;</Iconfont>
            </FacebookShareButton>

            <PinterestShareButton
                url={shareUrl?.pinterest}
                media={`${IMAGE_GEEKO_LTD}/large/${selectedProduct?.id}`}
                description={selectedProduct?.name}
                onShareWindowClose={()=>shareSuccess("pintrest")}
            >
                <Iconfont className={classes.FacebookIcon}>&#xe65f;</Iconfont>
            </PinterestShareButton>
        </div>

        {
            customer?.id && !customer?.subscribeToFacebookMessage && <div className={classes.FacebookMessenger}>
                <SendToMessenger customerId={customer.id}/>
            </div>
        }
        
    </div>
}

const YoutubeDuration = props =>{
    const { selectedProduct, selectedImage, firstYoutube } = props;
    const [muted, setMted] = useState(true);
    const [showPlayer, setShowPlayer] = useState(false);
    const playerRef = useRef(null);
    const startTime = useRef();
    let initedRef = useRef(false);
    const imageRef = useRef(selectedImage);
    const [entered, setEntered] = useState(false)
    const innerRef = useRef();

    const scrollHandle = useCallback(evt => {
        const rect = innerRef.current.getBoundingClientRect()
        if (rect.bottom > 0 && rect.bottom <= 100) {
            setEntered(true)
        }else{
            setEntered(false)
        }
    }, [])
        
    useEffect(() => {
        firstYoutube && window.addEventListener('scroll', scrollHandle)

        return () => {
            window.removeEventListener('scroll', scrollHandle)
        }
    }, [])

    useEffect(() =>{
        if(!initedRef.current && (entered || (selectedImage !== imageRef.current)) && showPlayer){
            initedRef.current = true;
            // imageRef.current = selectedImage;
            let endTime  = parseInt(new Date().getTime()/1000);

            window.removeEventListener('scroll', scrollHandle)

            if (window.GeekoSensors) {
                window.GeekoSensors.Track('VideoPlay', {
                    duration:endTime - startTime.current,
                    product_id:selectedProduct?.id
                })
            }
        }
    },[selectedImage, showPlayer, entered]);

    useEffect(()=>{
        if(selectedProduct?.id){
            setShowPlayer(false);
        }
    },[selectedProduct?.id]);

    const videoMuted = () =>{
        // let playerItem = playerRef.current?.getInternalPlayer();
        //
        // if(playerItem.isMuted()){
        //     setMted(false);
        // }else{
        //     setMted(true);
        // }
        setMted(!muted);
    }

    const youtubePlayEvent = (event) => {
        event.stopPropagation();
        setShowPlayer(true);

        startTime.current = parseInt(new Date().getTime()/1000);

        if (window.GeekoSensors) {
            window.GeekoSensors.Track('VideoClick', {
                is_success: true,
            })
        }
    }
    
    return <React.Fragment>
        {
            firstYoutube && <div style={{width:"100%",height:"100%",position:"absolute",left:0,top:0}} ref={innerRef}>
                {
                    showPlayer ? <React.Fragment>
                        <ReactPlayer 
                            className={classes.Player}
                            ref={playerRef}
                            width='100%'
                            height='100%'
                            url={selectedProduct?.listingVideoLink}
                            muted={muted}
                            // loop
                            volume={0.5}
                            playing={showPlayer}
                            onStart={() => {}}
                            config={{
                                youtube: {
                                    playerVars: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy:3 },
                                    embedOptions: { showinfo: 0, controls: 0, modestbranding: 1, playsinline: 1, autohide: 1, rel: 0, iv_load_policy:3 }
                                }
                            }} 
                            onEnded={()=>{setShowPlayer(false)}}
                        />
                        <div className={classes.YoutubeMask2} onClick={event=>{event.stopPropagation()}}></div>
                        <div className={`${classes.YoutubeMuted} ${muted?"":classes.Active}`} onClick={videoMuted}></div>
                    </React.Fragment> : <React.Fragment>
                        <div className={classes.YoutubeMask} onClick={youtubePlayEvent}>
                            <span className={classes.BoFang}></span>
                        </div>
                    </React.Fragment>
                }
            </div>
        }
    </React.Fragment>
}

const RightMainImage = props =>{
    const { 
            selectedImage, 
            imagePrefix, 
            hoverImage, 
            selectedProduct, 
            images, 
            currentIndex,
        } = props;
    const [selectImage,setSelectImage] = useState(null);
    const dispatch = useDispatch();
    // selectedProduct.listingVideoLink="https://image.geeko.ltd/video/965955c2-ec8c-4160-a1bb-99fb73b0b6ed"
    const firstYoutube = currentIndex===0 && selectedProduct?.listingVideoLink;
    const pageProduct = useSelector((state) => state.pageProduct);

    const [zoom,setZoom] = useState(false);

    useEffect(() => {
        if (selectedProduct?.listingVideoLink && window.GeekoSensors) {
            window.GeekoSensors.Track('VideoExpose', {
                is_success: true,
            })
        }
    }, []);

    const zommImage = (image) =>{
        if(!firstYoutube){
            dispatch(setZoomImagePopover({image:image,images:[selectedProduct?.pcMainImage,...(selectedProduct?.pcExtraImageUrls || [])],prefix:`${IMAGE_GEEKO_LTD}/original`}))

            if(window.GeekoSensors){
                window.GeekoSensors.Track('ELClick', {
                    clicks:'pic',
                    product_sku: selectedProduct?.parentSku,
                    resource_content: image,
                    resource_position: currentIndex,
                    product_sort: 'product'
                })
            }
        }
    }
    
    return <div className={classes.RightMainContainer}>
        <div 
            className={classes.MainImage}
            onClick={()=>zommImage(selectedImage)}
            onMouseEnter={()=>setZoom(true)}
            onMouseLeave={()=>setZoom(false)}
        >
            <InnerImageZoom 
                src={`${imagePrefix}/large/${selectedImage}`}
                zoomSrc={`${imagePrefix}/original/${selectedImage}`} 
                width={600}
                height={750}
                zoomScale={1.3333}
                zoomPreload={zoom}
                fullscreenOnMobile
                hideHint
                hasSpacer
                zoomType="hover"
            />

            {
                hoverImage && <div className={classes.ImageHover} style={{backgroundImage:`url(${imagePrefix}/large/${hoverImage})`}}></div>
            }

            <YoutubeDuration selectedProduct={selectedProduct} selectedImage={selectedImage} firstYoutube={firstYoutube} />
            
            {/* <ShopSimilar image={selectedImage} productId={selectedProduct?.id} /> */}
        </div>
        
        <ProductShareContainer selectedProduct={selectedProduct} zoom={zoom} />

        {
            selectImage && <ZoomImagePopover images={images?.slice(0,1)} selectedImage={selectImage} onClose={()=>setSelectImage(null)} />
        }
    </div>
}

const LeftImageContainer = props =>{
    useStyles(classes);
    const { productHooks, imagePrefix, hoverImage } = props;
    const { selectedProduct } = productHooks;
    const [currentIndex,setCurrentIndex] = useState(0);

    let images = [selectedProduct?.pcMainImage, ...(selectedProduct?.pcExtraImageUrls || [])];

    // if(selectedProduct?.listingVideoLink){
    //     images = [selectedProduct?.pcMainImage,selectedProduct?.pcMainImage, ...(selectedProduct?.pcExtraImageUrls || [])];
    // }
    

    const [selectedImage,setSelectedImage] = useState(images?.[0]);

    return <div className={classes.LeftImageContainer}>
        <LeftImageList 
            product={selectedProduct}
            imagePrefix={imagePrefix}
            currentIndex={currentIndex}
            images={images}
            changeSelectedImage={(imageUrl)=>setSelectedImage(imageUrl)}
            changeCurrentIndex={(index)=>setCurrentIndex(index)}
        />
        <RightMainImage 
            selectedImage={selectedImage} 
            hoverImage={hoverImage}
            imagePrefix={imagePrefix}
            currentIndex={currentIndex}
            images={images}
            selectedProduct={selectedProduct}
        />
    </div>
}

export default LeftImageContainer;